import dataManager from '@/lib/engine';
import { CE_DRAFT_BRANCH, CE_MAIN_BRANCH } from '@/constants';
import actions from './actions';
import mutations from './mutations';

const getters = {
  getMasterTOC: () => (id, context, viewType) => {
    return dataManager.getTOCFromID(CE_MAIN_BRANCH, id, context, viewType);
  },

  getDraftTOC: () => (id, context, viewType) => {
    return dataManager.getTOCFromID(CE_DRAFT_BRANCH, id, context, viewType);
  },

  getDraftViewModules: () => () => {
    return dataManager.getAllModules(CE_DRAFT_BRANCH);
  },

  getAdminViewModules: () => () => {
    return dataManager.getAllModules(CE_MAIN_BRANCH);
  },

  getPageHistory: (state) => () => {
    return state.pageHistory;
  },

  getPageCommitOID: (state) => () => {
    return state.pageCommitOID;
  },

  getPageCommitTimestamp: (state) => () => {
    return state.pageCommitTimestamp;
  }
};

const state = {
  initialised: false,
  tocState: dataManager.MANAGER_STATE.STATE_IDLE,
  moduleState: dataManager.MANAGER_STATE.STATE_IDLE,
  pageHistory: [],
  pageCommitOID: '',
  pageCommitTimestamp: '',
  unpublishedUpdatesState: dataManager.MANAGER_STATE.STATE_IDLE
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
